export const configLightningNowcastDh = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_THNDR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_NOWCAS_THNDR",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_THNDR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 6,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configLightningNowcastLayer = {
  "Name": "JMA_THNDR",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [128, 128, 128, 25],
        "palette": [
          [128, 128, 128, 25],
          [0, 0, 0, 0],
          [255, 255, 0, 150],
          [255, 165, 0, 150],
          [255, 0, 0, 150],
          [128, 0, 128, 150]
        ]
      },
      "clear_coverage": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [255, 255, 0, 150],
          [255, 165, 0, 150],
          [255, 0, 0, 150],
          [128, 0, 128, 150]
        ]
      }
    }
  }
};
